import { Drop } from 'grommet';
import { Menu } from 'lucide-preact';
import { ComponentProps, ReactNode } from 'preact/compat';
import { useRef, useState } from 'preact/hooks';

import { cn } from '@/lib/utils';

interface BurgerMenuProps extends ComponentProps<'div'> {
  children: ReactNode;
}

const BurgerMenu = ({ className, children, ...props }: BurgerMenuProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => setShowMenu(!showMenu);
  const closeMenu = () => setShowMenu(false);

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div ref={ref} className={cn('', className)} {...props}>
      <button
        type="button"
        className="preflight preflight-button flex size-10 items-center justify-center"
        onMouseDown={toggleMenu}
      >
        <Menu className="size-5" />
        <span className="sr-only">Toggle Menu</span>
      </button>
      {showMenu && (
        <Drop
          align={{ top: 'bottom' }}
          pad={{ bottom: '20px' }}
          target={ref.current ?? undefined}
          elevation="xlarge"
          width="100%"
          round="false"
          onClickOutside={closeMenu}
        >
          {children}
        </Drop>
      )}
    </div>
  );
};

export default BurgerMenu;
